import { ReactGrid, Column, Row, CellChange } from "@silevis/reactgrid";
import "@silevis/reactgrid/styles.css";
import { usePricingStore } from "../../../providers/stores/pricing-store";
import { Rate, RatesProps } from "../types/RateTypes";
import { IIndexable } from "../../common/types/CommonTypes";
import { parseNumber } from "../../../helpers";

const getColumns = (): Column[] => [
	{ columnId: "legend", width: 10 },
	{ columnId: "date", width: 125 },
	{ columnId: "cost", width: 60 },
	{ columnId: "bookingCode", width: 150 },
	{ columnId: "quantity", width: 75 },
	{ columnId: "sold", width: 50 },
	{ columnId: "isFreeSell", width: 80 },
	{ columnId: "isSoldOut", width: 80 },
	{ columnId: "minNights", width: 90 }
];

const headerRow: Row = {
	rowId: "header",
	cells: [
		{ type: "header", text: "" },
		{ type: "header", text: "Date" },
		{ type: "header", text: "Cost" },
		{ type: "header", text: "Booking Code" },
		{ type: "header", text: "Quantity" },
		{ type: "header", text: "Sold" },
		{ type: "header", text: "Free Sell" },
		{ type: "header", text: "Sold Out" },
		{ type: "header", text: "Min Nights" }
	]
};

const indicatorRenderer = (rate: Rate) => {
	return (
		<span title={rate.errors.join('\r\n')}>{`\u2B24`}</span>
	)
}

const getRows = (rates: Rate[]): Row[] => [
	headerRow,
	...rates.map<Row>((rate, idx) => ({
		rowId: idx,
		cells: [
			{
				type: "text",
				renderer: (text: string) => indicatorRenderer(rate),
				text: '\u2B24',
				nonEditable: true,
				className: `indicator ${(!rate.isValid ? 'error' : (rate.isModified ? 'modified' : 'existing'))}`,
				errorMessage: rate.errors.join('\r\n')
			},
			{ type: "text", text: rate.date, nonEditable: true },
			{ type: "number", value: rate.cost },
			{ type: "text", text: rate.bookingCode },
			{ type: "number", value: rate.quantity },
			{ type: "number", value: rate.sold },
			{ type: "checkbox", checked: rate.isFreeSell },
			{ type: "checkbox", checked: rate.isSoldOut },
			{ type: "number", value: rate.minNights }
		]
	}))
];

const applyChangesToRates = (
	changes: CellChange[],
	prevRates: Rate[]
): Rate[] => {
	changes.forEach((change) => {
		const rateIndex = change.rowId;
		const rowIndex = Number(rateIndex);
		const prevRate = prevRates.at(rowIndex) as IIndexable;
		const fieldName = change.columnId;

		prevRate.isModified = true;

		switch (change.type) {
			default:
				break;
			case 'text':
				prevRate[fieldName] = change.newCell.text;
				break;
			case 'number':
				if (fieldName === 'quantity' && change.newCell.value > 0) {
					console.log('set isFreeSell');
					prevRate['isFreeSell'] = false;
				}
				prevRate[fieldName] = change.newCell.value;
				break;
			case 'checkbox':
				prevRate[fieldName] = change.newCell.checked;
				break;
		}
	});
	return [...prevRates];
};

export const RatesGrid = (props: RatesProps) => {

	const { setRates } = usePricingStore();

	const rows = getRows(props.rates);
	const columns = getColumns();

	const handleChanges = (changes: CellChange[]) => {
		setRates(applyChangesToRates(changes, props.rates));
	};

	return <ReactGrid rows={rows} columns={columns} onCellsChanged={handleChanges} />;
}